<template>
  <div id="app">
    <section id="home" class="section headerWrapper">
      <NavigationComponent />
      <div id="header" class="header">
        <HeroComponent />
      </div>
    </section>
    <section id="profile-section" class="section">
    </section>
    <section id="profile" class="container">
      <ProfileComponent />
    </section>
    <section class="container">
      <AboutComponent />
    </section>
    <section id="ribeira" class="ribeira">
      <h1 class="overlay">RIBEIRA</h1>
    </section>
    <section id="curriculum-section" class="section">
    </section>
    <section id="curriculum">
      <CurriculumComponent />
    </section>
    <section id="liverpool" class="liverpool">
      <h1 class="overlay">LIVERPOOL</h1>
    </section>
    <section id="skills-section" class="section">
    </section>
    <section id="skills">
      <SkillsComponent />
    </section>
    <section id="work-section" class="section">
    </section>
    <section id="work">
      <WorkFlowComponent />
      <WorkComponent />
    </section>
    <section id="recommendations-section" class="section">
    </section>
    <section id="recommendations">
      <RecommendationsComponent />
      <HobbiesComponent />
    </section>
    <section id="contact-section" class="section">
    </section>
    <section id="contact-form">
      <ContactComponent />
    </section>
    <section id="footer">
      <FooterComponent />
    </section>
    <AskBubbleComponent />
    <router-view />
  </div>
</template>

<script>
import ProfileComponent from "@/components/ProfileComponent";
import ContactComponent from "@/components/ContactComponent";
import CurriculumComponent from "@/components/CurriculumComponent";
import HeroComponent from "@/components/HeroComponent";
import NavigationComponent from "@/components/NavigationComponent";
import SkillsComponent from "@/components/SkillsComponent";
import AboutComponent from "@/components/AboutComponent";
import FooterComponent from "@/components/FooterComponent";
import WorkComponent from "@/components/WorkComponent";
import WorkFlowComponent from "@/components/WorkFlowComponent";
import RecommendationsComponent from "@/components/RecommendationsComponent";
import HobbiesComponent from "@/components/HobbiesComponent";
import AskBubbleComponent from "@/components/AskBubbleComponent";

export default {
  name: "Home",
  components: {
    HeroComponent,
    NavigationComponent,
    AboutComponent,
    ProfileComponent,
    CurriculumComponent,
    SkillsComponent,
    ContactComponent,
    WorkFlowComponent,
    WorkComponent,
    FooterComponent,
    RecommendationsComponent,
    HobbiesComponent,
    AskBubbleComponent
  }
};
</script>
